/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const WarningAlt: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <g clipPath='url(#clip0_20400_892)'>
      <path
        d='M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM13.645 5L13 14H11L10.392 5H13.645ZM12 20C10.895 20 10 19.105 10 18C10 16.895 10.895 16 12 16C13.105 16 14 16.895 14 18C14 19.105 13.105 20 12 20Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_20400_892'>
        <rect width='24' height='24' fill='currentColor' />
      </clipPath>
    </defs>
  </React.Fragment>
)
